import type { GraphStore } from "./types"

// Named selectors to prevent unnecessary re-renders
export const selectRootCustomerId = (state: GraphStore) => state.rootCustomerId
export const selectSelectedVertices = (state: GraphStore) => state.selectedVertices
export const selectHoveredNode = (state: GraphStore) => state.hoveredNode
export const selectSidebarLockedNode = (state: GraphStore) => state.sidebarLockedNode
export const selectSidebarVisible = (state: GraphStore) => state.sidebarVisible
export const selectDisableInteractions = (state: GraphStore) => state.disableInteractions
export const selectCanvasWidth = (state: GraphStore) => state.canvasWidth
export const selectCanvasHeight = (state: GraphStore) => state.canvasHeight
export const selectPanPosition = (state: GraphStore) => state.panPosition
export const selectZoomLevel = (state: GraphStore) => state.zoomLevel

// Action selectors
export const selectSetRootCustomerId = (state: GraphStore) => state.setRootCustomerId
export const selectSetSelectedVertices = (state: GraphStore) => state.setSelectedVertices
export const selectToggleVertexSelection = (state: GraphStore) => state.toggleVertexSelection
export const selectSetHoveredNode = (state: GraphStore) => state.setHoveredNode
export const selectToggleSidebarLock = (state: GraphStore) => state.toggleSidebarLock
export const selectCloseSidebar = (state: GraphStore) => state.closeSidebar
export const selectSetDisableInteractions = (state: GraphStore) => state.setDisableInteractions
export const selectSetCanvasDimensions = (state: GraphStore) => state.setCanvasDimensions
export const selectSetPanPosition = (state: GraphStore) => state.setPanPosition
export const selectSetZoomLevel = (state: GraphStore) => state.setZoomLevel
export const selectResetPanAndZoom = (state: GraphStore) => state.resetPanAndZoom
export const selectResetStore = (state: GraphStore) => state.resetStore

let lastSelectedVertices: string[] = []
let lastCurrentNodeId: string | undefined

export const selectCurrentNodeId = (state: GraphStore) => {
  if (state.selectedVertices === lastSelectedVertices) {
    return lastCurrentNodeId
  }

  lastSelectedVertices = state.selectedVertices
  lastCurrentNodeId = state.selectedVertices.length
    ? state.selectedVertices[state.selectedVertices.length - 1]
    : undefined

  return lastCurrentNodeId
}
